import React, { ReactElement } from 'react';

import Row from '@amzn/meridian/row';
import { SelectOption } from '@amzn/meridian/select';
import Text from '@amzn/meridian/text';

import { IndexMetadata } from 'src/components/Agreements';
import { RowTag } from 'src/components/Agreements/SearchBar/RowTag';
import { IndexSuggestion } from 'src/util/search-index';

export function getCategoryWidths(suggestions: IndexSuggestion<IndexMetadata>[]): number {
    return suggestions
        .flatMap((suggestion) => {
            return suggestion.items.map((key) => key.value.dataType);
        })
        .map((dataType) => dataType.length)
        .reduce((prev, cur) => Math.max(prev, cur), 0);
}

export function renderSuggestions(suggestions: IndexSuggestion<IndexMetadata>[], tagWidth: string) {
    return suggestions.flatMap((suggestion) => {
        const dataTypes = new Map(suggestion.items.map((key) => [key.value.dataType, key.value.colorClass]));
        const result: ReactElement[] = [];
        dataTypes.forEach((colorClass, dataType) =>
            result.push(selectOption(suggestion.token, dataType, colorClass, tagWidth))
        );
        return result;
    });
}

export function selectOption(text: string, searchType: string, colorClass: string, width?: string) {
    return (
        <SelectOption label={`${searchType}: ${text}`} value={`${searchType}: ${text}`}>
            {() => (
                <Row>
                    <RowTag searchType={searchType} width={width} colorClass={colorClass} />
                    <Text>{text}</Text>
                </Row>
            )}
        </SelectOption>
    );
}
